// ---------------------------------------------------------------------------
// Conteúdo centralizado da landing page — Dra. Sâmia Albuquerque
// Edite este arquivo para atualizar textos, links e informações profissionais.
// ---------------------------------------------------------------------------

export const site = {
  name: "Dra. Sâmia Albuquerque",
  shortName: "Sâmia Albuquerque",
  role: "Médica",
  crm: "CREMEC 16.773",
  location: "Fortaleza, Ceará",
  locationShort: "Fortaleza–CE",
  instagramHandle: "@drasamiaalbuquerque",
  instagramUrl: "https://www.instagram.com/drasamiaalbuquerque",
  whatsappNumber: "5585981022809",
  whatsappDisplay: "(85) 98102-2809",
  whatsappMessage:
    "Olá, vim pelo site da Dra. Sâmia Albuquerque e gostaria de agendar uma avaliação.",
  whatsappLink: "https://api.whatsapp.com/message/JTZIQVYFFVFWN1?autoload=1&app_absent=0",
};

export const formConfig = {
  formId: "daa1lp1tacug2b80t0gg",
  submitAddr: "https://readdy.ai/api/form/daa1lp1tacug2b80t0gg",
};

export const navItems = [
  { id: "inicio", label: "Início" },
  { id: "sobre", label: "Sobre" },
  { id: "tratamentos", label: "Tratamentos" },
  { id: "pisom", label: "Tecnologia PISOM" },
  { id: "faq", label: "Perguntas frequentes" },
];

export const topBarText =
  "Dra. Sâmia Albuquerque • Médica • CREMEC 16.773 • Fortaleza–CE";

export const positioningConcepts = [
  "Disciplina",
  "Excelência",
  "Propósito",
  "Naturalidade",
];

export const hero = {
  eyebrow: "Medicina estética em Fortaleza",
  title: "Beleza natural, cuidado médico e escolhas feitas para você.",
  subtitle:
    "Uma abordagem individualizada para cuidar da pele, valorizar seus traços e acompanhar o envelhecimento de forma equilibrada.",
  primaryCta: "Agendar minha avaliação",
  secondaryCta: "Conhecer os tratamentos",
  microtext: "Atendimento mediante agendamento em Fortaleza–CE.",
  seal: "Médica • CREMEC 16.773",
  scriptTag: "de dentro para fora",
  backgroundImage:
    "https://storage.helloreaddy.io/project_files/dc7d9f67-9264-4ce6-bb20-73f16f487f5c/bbdee830-d045-4339-80e2-7a3a366da7e2_compressed_Imagem-do-Codex-30-de-ago.-de-2026-09_39_15.webp",
};

export const about = {
  title: "Medicina, propósito e beleza natural.",
  paragraphs: [
    "A Dra. Sâmia Albuquerque formou-se em Medicina pela Unichristus há mais de 10 anos. Iniciou sua trajetória na Medicina de Família, desenvolvendo uma visão baseada no cuidado integral. Também passou pela emergência infantil, onde adquiriu experiência em situações delicadas.",
    "Inspirada por uma vida saudável, realizou pós-graduação em Nutrologia pela ABRAN e atuou na área por alguns anos. Posteriormente, encontrou na medicina estética sua verdadeira vocação.",
    "Hoje, seu trabalho é dedicado a valorizar a beleza natural, promover autoestima e bem-estar e auxiliar no gerenciamento equilibrado do envelhecimento.",
  ],
  quote:
    "Meu propósito é cuidar de cada paciente de forma individualizada, respeitando sua identidade e valorizando sua beleza natural.",
  highlights: [
    {
      value: "10+",
      label: "anos de formação médica",
    },
    {
      value: "Individual",
      label: "cuidado individualizado",
    },
    {
      value: "Estética",
      label: "atuação em medicina estética",
    },
  ],
};

export const philosophy = {
  title: "Cuidar da aparência também é cuidar de como você se sente.",
  cards: [
    {
      title: "Naturalidade",
      text: "Planos de cuidado pensados para valorizar características individuais.",
      icon: "ri-leaf-line",
    },
    {
      title: "Individualização",
      text: "Cada indicação começa com escuta, avaliação médica e compreensão dos objetivos da paciente.",
      icon: "ri-user-heart-line",
    },
    {
      title: "Equilíbrio",
      text: "Estratégias voltadas ao cuidado da pele, à autoestima e ao envelhecimento equilibrado.",
      icon: "ri-scales-3-line",
    },
  ],
};

export const treatments = {
  title: "Possibilidades de cuidado para diferentes momentos.",
  intro:
    "A indicação de qualquer tratamento depende de avaliação médica individual, histórico clínico, objetivos e características de cada paciente.",
  disclaimer:
    "Os procedimentos apresentados podem não ser indicados para todas as pessoas. Benefícios, riscos, contraindicações e alternativas serão discutidos durante a consulta.",
  categories: [
    {
      title: "Expressão e contorno",
      items: [
        "Toxina botulínica full face",
        "Tratamento de hiperidrose axilar",
        "Preenchimentos faciais com ácido hialurônico",
        "Bioestimuladores de colágeno faciais",
        "Fios de PDO",
      ],
    },
    {
      title: "Pele e regeneração",
      items: [
        "Microagulhamento",
        "PDRN",
        "Tratamento de acne",
        "Tratamento de melasma",
      ],
    },
    {
      title: "Corpo e estímulo de colágeno",
      items: [
        "Bioestimuladores corporais",
        "Esvaziadores de gordura faciais e corporais",
        "Ultrassom macro e microfocado",
      ],
    },
    {
      title: "Tecnologias",
      items: ["Laser PISOM", "Laser CO₂"],
    },
  ],
};

export const pisom = {
  eyebrow: "Tecnologia para o cuidado da pele",
  title: "Laser PISOM: cuidado tecnológico e abordagem individualizada.",
  text: "O PISOM é uma tecnologia de laser que pode integrar protocolos voltados à aparência da pele, sempre conforme avaliação médica.",
  indicationsTitle: "Possíveis indicações avaliadas individualmente",
  indications: [
    "Aparência de poros dilatados",
    "Manchas e melasma",
    "Textura e tonalidade irregulares",
    "Linhas finas",
    "Fotoenvelhecimento",
    "Cicatrizes",
    "Estrias",
    "Acne",
    "Algumas lesões pigmentares",
    "Flacidez da pele",
    "Queda de cabelo, quando houver indicação adequada",
  ],
  discomfortNote:
    "A percepção de desconforto pode variar entre pacientes e conforme o protocolo utilizado.",
  cta: "Conversar sobre o PISOM",
};

export const journey = {
  title: "Como funciona o atendimento?",
  steps: [
    {
      title: "Conversa inicial",
      text: "Entendimento das suas necessidades, expectativas e histórico.",
    },
    {
      title: "Avaliação médica",
      text: "Análise individual da pele, dos traços e das possíveis indicações.",
    },
    {
      title: "Plano de cuidado",
      text: "Definição compartilhada das opções, prioridades e etapas.",
    },
    {
      title: "Acompanhamento",
      text: "Orientações e acompanhamento de acordo com o tratamento realizado.",
    },
  ],
};

export const experience = {
  title: "Uma experiência pautada em atenção, segurança e cuidado.",
  text: "Do primeiro contato ao acompanhamento, cada etapa deve proporcionar clareza, acolhimento e tranquilidade.",
};

export const testimonials = {
  title: "O que dizem as pacientes",
  placeholder:
    "Depoimentos reais poderão ser adicionados aqui após autorização expressa das pacientes e revisão das regras aplicáveis à publicidade médica.",
};

export const faq = {
  title: "Perguntas frequentes",
  items: [
    {
      question: "Como saber qual tratamento é indicado para mim?",
      answer:
        "A indicação de qualquer tratamento depende de uma avaliação médica individual, que considera seu histórico, suas características e seus objetivos. Por isso, o primeiro passo é uma consulta.",
    },
    {
      question: "A primeira consulta já inclui um plano de cuidado?",
      answer:
        "Durante a avaliação, conversamos sobre suas necessidades e expectativas. A partir dessa análise, as opções e prioridades são definidas de forma compartilhada, conforme o seu caso.",
    },
    {
      question: "Os resultados são iguais para todas as pessoas?",
      answer:
        "Não. Cada pessoa responde de uma forma. Resultados, recuperação e número de sessões podem variar conforme características individuais e o tratamento realizado.",
    },
    {
      question: "Existem contraindicações?",
      answer:
        "Sim. Cada procedimento possui indicações e contraindicações específicas, que são avaliadas individualmente durante a consulta.",
    },
    {
      question: "Quantas sessões podem ser necessárias?",
      answer:
        "O número de sessões varia conforme o procedimento e a avaliação individual. Essa definição é feita de forma compartilhada, considerando os objetivos de cada paciente.",
    },
    {
      question: "Como funciona o acompanhamento?",
      answer:
        "O acompanhamento ocorre de acordo com o tratamento realizado, com orientações e retornos definidos junto à paciente.",
    },
    {
      question: "Onde acontecem os atendimentos?",
      answer:
        "Os atendimentos acontecem em Fortaleza–CE, mediante agendamento.",
    },
    {
      question: "Como posso agendar?",
      answer:
        "Você pode agendar pelo WhatsApp, clicando no botão de agendamento, ou preenchendo o formulário de contato do site.",
    },
  ],
};

export const finalCta = {
  title: "Seu cuidado começa com uma avaliação individual.",
  text: "Converse com a equipe e agende um horário para conhecer as possibilidades adequadas aos seus objetivos.",
  cta: "Agendar pelo WhatsApp",
  note: "Fortaleza–CE • Atendimento mediante agendamento",
};

export const footerDisclaimer =
  "As informações deste site têm caráter educativo e institucional. Elas não substituem consulta, diagnóstico ou avaliação médica individual. Indicações, contraindicações, benefícios, riscos, recuperação e resultados variam conforme cada paciente.";

export const formFieldOptions = {
  procedures: [
    "Toxina botulínica",
    "Preenchimento facial",
    "Bioestimuladores de colágeno",
    "Fios de PDO",
    "Microagulhamento",
    "Tratamento de melasma",
    "Tratamento de acne",
    "Laser PISOM",
    "Laser CO₂",
    "Ultrassom",
    "Ainda não sei / quero orientação",
  ],
  periods: ["Manhã", "Tarde", "Fim de tarde", "Sábado", "Qualquer horário"],
};

// Placeholders das fotografias — substitua pelas imagens reais fornecidas.
export const photoPlaceholders = {
  hero: "[FOTO HERO — retrato profissional da Dra. Sâmia]",
  consultorio: "[FOTO CONSULTÓRIO — médica ao lado do equipamento]",
  sobre: "[FOTO SOBRE — retrato com blazer claro]",
  detalhe: "[FOTO DETALHE — ambiente ou atendimento]",
  lifestyle: "[FOTO LIFESTYLE — imagem elegante e natural]",
};